import { render } from "./GameShell.vue?vue&type=template&id=8ef33ee2&scoped=true"
import script from "./GameShell.vue?vue&type=script&lang=js"
export * from "./GameShell.vue?vue&type=script&lang=js"

import "./GameShell.vue?vue&type=style&index=0&id=8ef33ee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ef33ee2"]])

export default __exports__